import { render, staticRenderFns } from "./ReserveItems.vue?vue&type=template&id=524a9129"
import script from "./ReserveItems.vue?vue&type=script&lang=ts"
export * from "./ReserveItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports